const INITIAL_STATE = {
  storedData: {},
  storedGeojson: {},
  dotDensityData: {},
  isTicking: false,
  canLoadInBackground: false
};

export default INITIAL_STATE